import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.252 11.25a.75.75 0 0 1 0 1.5h-16.5a.75.75 0 0 1 0-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.113 5.86a.75.75 0 0 1 1.06 0l5.61 5.61a.75.75 0 0 1 0 1.06l-5.61 5.61a.75.75 0 1 1-1.06-1.061l5.079-5.08-5.08-5.08a.75.75 0 0 1 0-1.06"
    }, null, -1)
  ]))]))
}
export default { render: render }